import React, { useEffect, useState } from 'react';
import DeleteModal from '../../component/reusable/deleteModal/DeleteModal';
/* import { Container, Grid, Paper, Typography, Button, Box, Divider } from '@mui/material'; */
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ContactPhoneOutlinedIcon from '@mui/icons-material/ContactPhoneOutlined';
import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import { styled } from '@mui/material/styles';
import { Address, Billing, Contact, Copy, Customer, CustomerInfo, download, EmailBox, Filter, Payment, Phone, Shipping, ShippingID, ShippingMethod, Users } from '../../Svg';
import NestedUserHeader from '../../component/reusable/NestedUserHeader';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { exportDataExcel, handleCopy } from '../../utils/fomateDate';
import {
  MenuItem,
  Menu,
  Button,
  Paper,
  Typography,
  Box,
  Divider, Grid

} from "@mui/material";
import { ArrowDropDown } from '@mui/icons-material';
import PartList from '../../component/bomComps/PartList/PartList';
import { toast } from 'react-toastify';
import { bomDetailsThunk, deleteProductFrombomThunk, setbomrefresh } from '../../redux/bomSlice';
import api from '../../utils/api';

const StyledGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderRadius: theme.shape.borderRadius,
}));

const ActionButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  marginRight: theme.spacing(1),
  fontSize: '0.875rem',
  color: '#512DA8',
  backgroundColor: '#F0F1F3',
  fontSize: '14px',
  fontWeight: '600 !important',
  fontFamily: `'Public Sans', sans-serif`,
  borderRadius: '8px',
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
  },
}));


const status = ["NEW", "QUOTED", "COMPLETED"]

const BomEnquiresDetails = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { id } = useParams()
  const { loading, refresh, bomEnquiryDetails } = useSelector((state) => state.bom);
  const enqdetails = encodeURIComponent(JSON.stringify(bomEnquiryDetails));
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (status) => {
    if (status) {
      changeStatus(status)
    }
    setAnchorEl(null);
  };


  useEffect(() => {
    dispatch(bomDetailsThunk(id))
  }, [refresh])

  const changeStatus = async (status) => {
    const datas = {
      id: bomEnquiryDetails?._id,
      status: status
    }
    try {
      const { data } = await api.updatebomStatus(datas)
      if (data) {
        toast.success('status updated succesfully')
        dispatch(setbomrefresh())
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.response?.data?.message || 'something went wrong')
    } finally {
    }
  }


  // Removing a part asks for the Super Admin password first
  const [partToDelete, setPartToDelete] = useState(null)
  const deleteProductFromenq = (selectedId) => setPartToDelete(selectedId)
  const confirmPartDelete = (password) => {
    const data = {
      id: bomEnquiryDetails?._id,
      partId: partToDelete,
      password
    }
    dispatch(deleteProductFrombomThunk(data))
    setPartToDelete(null)
  }
  // console.log(bomEnquiryDetails);

  if (loading) {
    return (
      <div>please wait...</div>
    )
  }


  const downLoadPo = () => {
    const data = bomEnquiryDetails?.partList?.map((pro) => ({
      "productNumber": pro?.productNumber,
      "quantity": pro?.quantity,
      "manufacturer": pro?.manufacturer
    }))
    exportDataExcel(data, 'Bom Po')
  }



  return (
    <>
      <DeleteModal isOpen={!!partToDelete} heading={'part'} onClose={() => setPartToDelete(null)} onDelete={confirmPartDelete} />
      <NestedUserHeader
        index={`BOM Enquiry #${bomEnquiryDetails?.enquiryId}`}
        root="Dashboard"
        buttonText={'Quote Now'}
        onClickadd={() => navigate(`/bom/bomQuote/${bomEnquiryDetails?.enquiryId}`)}
        show={bomEnquiryDetails?.status === 'COMPLETED' ? false : true}
      />


      <div style={{ borderLeft: "1px solid #DCDEE3", padding: "10px 20px" }}>
        <div style={{ display: 'flex', justifyContent: "space-between", padding: '20px 0px' }}>
          <div style={{ display: 'flex' }}>
            <Typography
              sx={{
                color: 'rgba(29, 31, 44, 1)',
                fontSize: '20px',
                fontWeight: '600',
                fontFamily: `'Public Sans', sans-serif`,
              }}>
              ID #{bomEnquiryDetails?.enquiryId}
            </Typography>
            <Typography style={{
              marginLeft: '10px', padding: "6px 4px", borderRadius: '8px', fontSize: '14px', fontWeight: "600",
              color: bomEnquiryDetails?.status === "NEW" ? "#4A4C56" : bomEnquiryDetails?.status === "QUOTED" ? "#00B789" : "#1A9882",
              background: bomEnquiryDetails?.status === "NEW" ? "#4A4C561A" : bomEnquiryDetails?.status === "QUOTED" ? "#EAFFFE" : "#E9FAF7",
            }}>
              {bomEnquiryDetails?.status}
            </Typography>
          </div>
          {/* {bomEnquiryDetails?.status != "COMPLETED" &&
            <div>
              <ActionButton
                onClick={handleClick}
                sx={{
                  color: '#667085',
                  border: '1px solid #E0E2E7',
                  background: '#fff',
                  borderRadius: '8px',
                }}
              >
                {bomEnquiryDetails?.status}
                <ArrowDropDown />
              </ActionButton>
              <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => handleClose('')}
                MenuListProps={{
                  'aria-labelledby': 'status-button',
                }}
              >
                {status?.map((i) => (

                  <MenuItem onClick={() => handleClose(i)}
                    sx={{
                      borderBottom: '1px solid #E6E1E5',
                      fontSize: '14px',
                      color: '#667085',
                    }}>{i}</MenuItem>
                ))
                }
              </Menu>
            </div>
          } */}
        </div>

        {loading ? <div>Please wait...</div> :
          <Box maxWidth="lg">
            <Grid container spacing={3}>
              <Grid item xs={12} md={7}>
                <Paper sx={{ height: '100%', boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px" }}>
                  <Box sx={{ p: 2, }} display="flex" alignItems="center" >
                    <CustomerInfo />
                    <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                      Customer Info
                    </Typography>
                  </Box>
                  <Divider sx={{ mb: 1 }} />
                  <Box sx={{ p: '24px 24px 0px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" >
                      <Customer />
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', width: 140, flexShrink: 0 }}>
                          Company:
                        </Typography>
                        <Box>
                          {/* Company first; the contact person's name below it */}
                          <Typography style={{ color: '#0C0D0F', fontSize: '14px', fontWeight: 600 }}>
                            {bomEnquiryDetails?.userId?.companyName || bomEnquiryDetails?.userId?.fullName || 'Customer unavailable'}
                          </Typography>
                          {bomEnquiryDetails?.userId?.companyName && bomEnquiryDetails?.userId?.fullName && (
                            <Typography style={{ color: '#727A90', fontSize: '13px' }}>{bomEnquiryDetails.userId.fullName}</Typography>
                          )}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                  <Box sx={{ p: '24px 24px 0px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" >
                      <EmailBox />
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', width: 140, flexShrink: 0 }}>
                          Email:
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          {bomEnquiryDetails?.userId?.email}
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <div onClick={() => handleCopy(bomEnquiryDetails?.userId?.email)}>
                        <Copy />
                      </div>
                    </Box>
                  </Box>
                  <Box sx={{ p: '24px 24px 0px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" >
                      <Phone />
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', width: 140, flexShrink: 0 }}>
                          Phone Number:
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          {bomEnquiryDetails?.userId?.phone}
                        </Typography>
                      </Box>
                    </Box>
                    <Box>
                      <div onClick={() => handleCopy(bomEnquiryDetails?.userId?.phone)}>
                        <Copy />
                      </div>
                    </Box>
                  </Box>
                  <Box sx={{ p: '18px 24px 14px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" >
                      <Address />
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', width: 140, flexShrink: 0 }}>
                          Shipping Address:
                        </Typography>
                        {/* One address per block, stacked */}
                        <Box display="flex" flexDirection="column" gap="8px">
                          {bomEnquiryDetails?.userId?.shippingAddress?.map((i, index) => (
                            <Typography key={index} style={{ color: '#0C0D0F', fontSize: '14px', lineHeight: 1.6 }}>
                              {i?.factoryUnits}<br />{i?.streetAddress}, {i?.state} - {i?.zipCode}, {i?.country}
                            </Typography>
                          ))}
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Paper>
              </Grid>


              <Grid item xs={12} md={5}>
                <Paper sx={{ boxShadow: '0px 4px 30px 0px #4D54640D', border: '1px solid #DCDEE3', borderRadius: "16px", height: '100%' }}>
                  <Box sx={{ p: 2, }} display="flex" alignItems="center" >
                    <Contact />
                    <Typography style={{ marginLeft: '10px', fontSize: '18px' }}>
                      Enquiry Info
                    </Typography>
                  </Box>
                  <Divider sx={{ mb: 1 }} />
                  <Box sx={{ p: '24px 24px 24px 24px', }} display="flex" alignItems="flex-start" justifyContent='space-between'>
                    <Box display="flex" flexDirection="column" gap='10px'>
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px' alignItems='center'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', width: 140, flexShrink: 0 }}>
                          BOM PO:
                        </Typography>
                        <Typography style={{ color: '#2D7BE8', fontSize: '14px', display: 'flex', alignItems: 'center', gap: 5 }} >
                          <div onClick={downLoadPo} style={{ cursor: 'pointer' }}>

                            BOM po.excel {download()}
                          </div>
                        </Typography>
                      </Box>
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', width: 140, flexShrink: 0 }}>
                          Project name:
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          {bomEnquiryDetails?.projectName}
                        </Typography>
                      </Box>
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', width: 140, flexShrink: 0 }}>
                          Application:
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          {bomEnquiryDetails?.application}
                        </Typography>
                      </Box>
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', width: 140, flexShrink: 0 }}>
                          Annual Volume:
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          {bomEnquiryDetails?.application}
                        </Typography>
                      </Box>
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', width: 140, flexShrink: 0 }}>
                          End customer:
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          {bomEnquiryDetails?.endCustomer}
                        </Typography>
                      </Box>
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', width: 140, flexShrink: 0 }}>
                          Biding/Buying:
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          {bomEnquiryDetails?.enquiryType}
                        </Typography>
                      </Box>
                      <Box style={{ marginLeft: '8px', }} display="flex" gap='20px'>
                        <Typography variant="body1" sx={{ color: '#727A90', fontSize: '14px', width: 140, flexShrink: 0 }}>
                          SOP:
                        </Typography>
                        <Typography style={{ color: '#0C0D0F', fontSize: '14px' }}>
                          {bomEnquiryDetails?.sop}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Paper>
              </Grid>


            </Grid>

            <PartList
              data={bomEnquiryDetails?.partList}
              deleteProductFromenq={deleteProductFromenq}
              status={bomEnquiryDetails?.status}
            />


          </Box>
        }
      </div>
    </>
  );
};

export default BomEnquiresDetails;
